import type { Module } from 'vuex'
import type { StoreState } from '../store-state'

/** 병원별 배지 수 — hospital[병원ID][키] = 값 */
export type BadgeState = {
    hospital: Record<string, Record<string, unknown> | undefined>
}

const state: BadgeState = {
    hospital: {},
}

type Store = { commit(type: string, payload: unknown): void }

const actions = {
    'AC_SetBadge': (store: Store, dic: { hospitalID: string; key: string; value: unknown }): void => {
        store.commit('MU_SetBadge', dic)
    },
}

const mutations = {
    'MU_SetBadge': (
        state: BadgeState,
        dic: { hospitalID: string; key: string; value: unknown },
    ): void => {
        const hospitalID = dic.hospitalID
        const badges = state.hospital[hospitalID] ?? {}
        badges[dic.key] = dic.value
        state.hospital[hospitalID] = badges
    },
}

const badge: Module<BadgeState, StoreState> = { state, actions, mutations }

export default badge
